// API 配置文件
// 自动获取当前域名
const currentHost = window?.location?.host || "localhost";
const currentProtocol = window?.location?.protocol || "http:";

const dynamicApiPre = `${currentProtocol}//${currentHost}`;
// 获取基础API URL，优先使用环境变量，其次使用相对路径
const BASE_URL = dynamicApiPre || process.env.VUE_APP_API_URL;

export const API_URLS = {
  LOGIN: `${BASE_URL}/admin/users/login`,
  LOGOUT: `${BASE_URL}/admin/users/logout`,
  APK_LIST: `${BASE_URL}/admin/ty2502ApkManager/apkVerList`,
  APK_VERSION_LIST: `${BASE_URL}/admin/ty2502ApkManager/apkVerNoList`,
  EDIT_REMARK: `${BASE_URL}/admin/ty2502ApkManager/editRemark`,
  UPLOAD_APK: `${BASE_URL}/admin/ty2502ApkManager/upgradeApk`,
  REPLACE_APK: `${BASE_URL}/admin/ty2502ApkManager/replaceApk`,
  GET_NEW_VERSION: `${BASE_URL}/admin/ty2502ApkManager/getNewApkVerNo`,
  GET_CURRENT_DOMAIN: `${BASE_URL}/admin/serverInfo/getInfoByReqHost`,
  GET_DOMAIN_LIST: `${BASE_URL}/admin/serverInfo/getServerListByReqHost`,
};

export default API_URLS;
